import React, { useCallback, useRef } from 'react';

export const useActionRefs = (): {
  actionRefs: React.MutableRefObject<Record<string, HTMLDivElement>>;
  registerActionRef: (customId: string) => (node: HTMLDivElement) => void;
} => {
  const actionRefs = useRef<Record<string, HTMLDivElement>>({});

  const registerActionRef = useCallback(
    (customId: string) => (node: HTMLDivElement) => {
      if (node) {
        actionRefs.current[customId] = node;
      } else {
        delete actionRefs.current[customId];
      }
    },
    [],
  );

  return { actionRefs, registerActionRef };
};
